module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_cat01-84dcb7b861c5b39534244e18b537ee03.svg";